import React, { useState } from 'react';
import {
  BarChart3,
  Layers,
  GitBranch,
} from 'lucide-react';
import { MetricsManagement } from './MetricsManagement';
import { ClusterManagement } from './ClusterManagement';
import { SubDimensionManagement } from './SubDimensionManagement';

export const MetricsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'metrics' | 'clusters' | 'subdimensions'>('metrics');

  const tabs = [
    { id: 'metrics', label: 'Metrics', icon: BarChart3 },
    { id: 'clusters', label: 'Clusters', icon: Layers },
    { id: 'subdimensions', label: 'Sub-dimensions', icon: GitBranch },
  ];

  return (
    <div className="min-h-screen bg-[#FFF8F5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: '"Tenor Sans", sans-serif' }}>
            Metrics Configuration
          </h1>
          <p className="mt-2 text-gray-600" style={{ fontFamily: '"Tenor Sans", sans-serif' }}>
            Manage metrics, clusters, and sub-dimensions for impact assessment
          </p>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-lg shadow-sm mb-6">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                const isActive = activeTab === tab.id;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id as typeof activeTab)}
                    className={`
                      flex-1 py-4 px-6 text-center border-b-2 font-medium text-sm
                      transition-colors duration-200 flex items-center justify-center gap-2
                      ${isActive 
                        ? 'border-[#FAAF90] text-[#E59873]' 
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }
                    `}
                    style={{ fontFamily: '"Tenor Sans", sans-serif' }}
                  >
                    <Icon className="w-5 h-5" />
                    {tab.label}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          {activeTab === 'metrics' && <MetricsManagement />}
          {activeTab === 'clusters' && <ClusterManagement />}
          {activeTab === 'subdimensions' && <SubDimensionManagement />}
        </div>
      </div>
    </div>
  );
};